"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.slugify = slugify;
function slugify(text) {
    return text
        .replace(/[`~!@#$%^*()_|+=?;:'",.<>{}[\]\\/]/gi, ' ') // replace special characters
        .trim() // remove leading & trailing whitespace
        .replace(/\s+/g, '-') // replace spaces with single dash
        .replace(/[\s-]+$/, '') // remove trailing dashes
        .toLowerCase();
}
